module.exports = __webpack_public_path__ + "static/media/Liver.2034d359.ogg";